import './BarLabelOverlay.css';
export var labelClipWrapper = '_b76tm82-3-8-0';
export var labelSpan = '_b76tm81-3-8-0';
export var overlayContainer = '_b76tm80-3-8-0';